import { Link } from 'react-router-dom';
import { CHECK_ANIMATED } from '../../../assets/animated';
import { Button } from '@wot/components';
export default function Success({ planId }: { planId: string }) {
  return (
    <div className="w-full h-full grow flex flex-col items-stretch bg-white z-20 ">
      <div className="w-full relative px-4 py-7 flex items-center justify-center bg-primaryPink ">
        <h3 className="text-xl font-semibold text-white">Plan Purchased</h3>
      </div>
      <div className="w-full grow flex flex-col items-center justify-center gap-2 px-7 py-7">
        <img src={CHECK_ANIMATED} className="w-20 h-20" />
        <p className="text-lg font-semibold text-center">Thank you for purchasing a plan with WorldOTutor!</p>
        <p className="text-sm font-medium">Select slots to schedule your classes!</p>

        <div className="w-full mt-auto">
          <Link to={`/my-plans?id=${planId}&bookSession=true`}>
            <Button block text="Great" type="primary" />
          </Link>
        </div>
      </div>
    </div>
  );
}
